import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
import { locations } from '../mockData';

const Locations = () => {
  const location = locations[0]; // Only one location now

  return (
    <section id="locations" className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex justify-center mb-4">
            <MapPin className="text-zinc-300" size={32} strokeWidth={1.5} />
          </div>
          <h2 className="text-5xl md:text-6xl font-light text-white mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>Our Location</h2>
          <div className="w-16 h-px bg-zinc-700 mx-auto mb-6"></div>
          <p className="text-zinc-400 max-w-2xl mx-auto font-light">
            Visit us and experience exceptional food
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Location Details */}
          <div className="bg-zinc-950 overflow-hidden hover:shadow-2xl hover:shadow-white/5 transition-all duration-500">
            <div className="relative overflow-hidden h-80">
              <img
                src={location.image}
                alt={location.name}
                className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
              <h3 className="absolute bottom-6 left-6 text-4xl font-light text-white" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                {location.name}
              </h3>
            </div>
            <div className="p-10 space-y-6">
              <div className="flex items-start gap-4">
                <MapPin className="text-zinc-400 flex-shrink-0 mt-1" size={20} strokeWidth={1.5} />
                <p className="text-zinc-300 font-light text-base">{location.address}</p>
              </div>
              <div className="flex items-center gap-4">
                <Phone className="text-zinc-400 flex-shrink-0" size={20} strokeWidth={1.5} />
                <p className="text-zinc-300 font-light text-base">{location.phone}</p>
              </div>
              <div className="flex items-center gap-4">
                <Clock className="text-zinc-400 flex-shrink-0" size={20} strokeWidth={1.5} />
                <p className="text-zinc-300 font-light text-base">{location.hours}</p>
              </div>
            </div>
          </div>

          {/* Google Map */}
          <div className="bg-zinc-950 overflow-hidden h-full min-h-[600px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1983.5447892345678!2d25.02345678901234!3d60.21234567890123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46920a3c8c8c8c8c%3A0x8c8c8c8c8c8c8c8c!2sKirkonkyl%C3%A4ntie%2034%2C%2000700%20Helsinki!5e0!3m2!1sen!2sfi!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="grayscale hover:grayscale-0 transition-all duration-500"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Locations;